export default {
  props: {
    bodyClass: {
      required: false,
      type: Array,
      default: () => ['webshop']
    }
  },
  created () {
    const body = document.getElementsByTagName('body').item(0)
    // First remove existing classes,
    // needed when previous route already set classes
    for (let existingClass of body.classList) {
      body.classList.remove(existingClass)
    }
    this.bodyClass.map((className) => body.classList.add(className))
  }
}



// WEBPACK FOOTER //
// ./src/mixins/body-class.js